import { cn } from "@/lib/utils";

// Brand lockup: uploaded RP emblem + "Real Estate Pro" wordmark beside it.
export function Logo({ variant = "light", className, emblemClass, emblemY = 5 }) {
  const isDark = variant === "dark";
  return (
    <span className={cn("inline-flex items-center gap-2.5 select-none", className)} data-testid="brand-logo">
      <img
        src="/emblem.png"
        alt="Real Estate Pro emblem"
        className={cn("h-[32px] w-auto md:h-[38px]", emblemClass)}
        style={{ transform: `translateY(${emblemY}px)` }}
        draggable={false}
      />
      <span className="whitespace-nowrap font-heading text-[18px] font-bold leading-none tracking-tight md:text-[22px]">
        <span className={isDark ? "text-white" : "text-re-charcoal"}>Real Estate </span>
        <span className="text-gradient-red">Pro</span>
      </span>
    </span>
  );
}
